import { render, staticRenderFns } from "./BillingPreview.vue?vue&type=template&id=70d8938e&"
import script from "./BillingPreview.vue?vue&type=script&lang=js&"
export * from "./BillingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports